<template>
    <div>
        <data-gathering-card
            v-if="filteredDataGatherings.length > 0"
            v-for="(dataGathering, index) in filteredDataGatherings"
            :key="index"
            :data-gathering="dataGathering"
        />
        <no-results v-else />
    </div>
</template>

<script>
import _ from "lodash";
import {mapState} from 'pinia';
import NoResults from "@/Shared/DathaGatherings/Common/NoResults";
import {EventBus} from "@/event-bus";
import {DataGatheringsStore} from "@/Store/DataGatherings/DataGatheringsStore";
import DataGatheringCard from "@/Shared/DathaGatherings/Common/DataGatheringCard";

export default {
    name: "DataGatheringCardList",

    components: {DataGatheringCard, NoResults},

    props: {

    },

    data: () => ({
        filters: {
            text: '',
            academic_periods: [],
            types: [],
            statuses: [],
        },

        textSearchFields: ['title', 'strategy.title', 'notes'],

        mapFiltersWithFields: [
            {
                key: 'academic_periods',
                field: 'academic_period.id',
            },
            {
                key: 'types',
                field: 'type.id',
            },
            {
                key: 'statuses',
                field: 'status',
            },
        ],
    }),

    computed: {
        filteredDataGatherings() {
            const textSearchFields = this.textSearchFields;
            let dataGatherings = this.dataGatherings;

            if(!dataGatherings){
                return [];
            }

            //first we filter the dataGathering search field, checking if contains some words wrote by the user
            let text = this.filters.text;
            if(text){
                dataGatherings = dataGatherings
                    .filter(
                        dataGathering => !!textSearchFields
                            .map(field => _.get(dataGathering, field, ''))
                            .firstOf(value => value && (value.indexOf(text) !== -1))
                    );
            }

            //then we apply the dedicated filters, if the conditions are empty then the filter is avoided
            dataGatherings = dataGatherings.filter(
                dataGathering => this.mapFiltersWithFields.length === this.mapFiltersWithFields.filter(filter => {
                    let conditions = _.get(this.filters, filter.key, []),
                        value = _.get(dataGathering, filter.field, ''),
                        noConditionInFilter = conditions.length <= 0,
                        conditionApplies = conditions.includes(value);

                    return noConditionInFilter || conditionApplies;
                }).length
            )

            // Finally, sort the dataGatherings by academic period and creation date, both in descending order
            return _.orderBy(dataGatherings, ['academic_period.title', 'created_at'], ['desc', 'desc']);
        },

        ...mapState(DataGatheringsStore, [
            'dataGatherings'
        ]),
    },

    methods: {
        applyFilters(filters) {
            this.filters = filters;
        },

        refresh(){
            this.$forceUpdate();
        },
    },

    created() {
        EventBus.$on('gicu-app.data-gatherings.filter', this.applyFilters);
        EventBus.$on('gicu-app.data-gatherings.update', this.refresh);
    },
}
</script>

<style scoped>

</style>
